import React from 'react'
import { logEvent } from '../../Utils'
import { WhiteBtnLink } from './styles'

type WhiteButtonLinkProps = {
  href: string
  center?: boolean
  analytics?: { event: string; params?: any }
  className?: string
}

export const WhiteButtonLink: React.FC<React.PropsWithChildren<WhiteButtonLinkProps>> = ({
  href,
  center,
  analytics,
  children,
  className,
}) => {
  const log = () => {
    analytics && logEvent(analytics.event, analytics.params)
  }
  if (center) {
    return (
      <>
        <WhiteBtnLink href={href} aria-label={`${analytics?.params?.title} - ${analytics?.params?.page}`} className={className}>
          <div className='button' onClick={() => log()}>
            {children}
          </div>
        </WhiteBtnLink>
      </>
    )
  } else {
    return (
      <WhiteBtnLink href={href} aria-label={`${analytics?.params?.title} - ${analytics?.params?.page}`} className={className}>
        <div className='button' onClick={() => log()}>
          {children}
        </div>
      </WhiteBtnLink>
    )
  }
}
